/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeleteReferralRecipientConfig200ResponseData } from './DeleteReferralRecipientConfig200ResponseData';
import {
    DeleteReferralRecipientConfig200ResponseDataFromJSON,
    DeleteReferralRecipientConfig200ResponseDataFromJSONTyped,
    DeleteReferralRecipientConfig200ResponseDataToJSON,
    DeleteReferralRecipientConfig200ResponseDataToJSONTyped,
} from './DeleteReferralRecipientConfig200ResponseData';

/**
 * 
 * @export
 * @interface DeleteReferralRecipientConfig200Response
 */
export interface DeleteReferralRecipientConfig200Response {
    /**
     * 
     */
    data?: DeleteReferralRecipientConfig200ResponseData;
}

/**
 * Check if a given object implements the DeleteReferralRecipientConfig200Response interface.
 */
export function instanceOfDeleteReferralRecipientConfig200Response(value: object): value is DeleteReferralRecipientConfig200Response {
    return true;
}

export function DeleteReferralRecipientConfig200ResponseFromJSON(json: any): DeleteReferralRecipientConfig200Response {
    return DeleteReferralRecipientConfig200ResponseFromJSONTyped(json, false);
}

export function DeleteReferralRecipientConfig200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteReferralRecipientConfig200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : DeleteReferralRecipientConfig200ResponseDataFromJSON(json['data']),
    };
}

export function DeleteReferralRecipientConfig200ResponseToJSON(json: any): DeleteReferralRecipientConfig200Response {
    return DeleteReferralRecipientConfig200ResponseToJSONTyped(json, false);
}

export function DeleteReferralRecipientConfig200ResponseToJSONTyped(value?: DeleteReferralRecipientConfig200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': DeleteReferralRecipientConfig200ResponseDataToJSON(value['data']),
    };
}

